<template>
  <div class="compliance-badges">
    <span class="badge badge-compliance">
      <i class="fas fa-check-circle mr-2"></i>
      Conforme GDPR
    </span>
    <span class="badge badge-compliance">
      <i class="fas fa-lock mr-2"></i>
      Dati Protetti
    </span>
    <span class="badge badge-compliance">
      <i class="fas fa-user-shield mr-2"></i>
      Privacy First
    </span>
  </div>
</template>

<script>
export default {
  name: 'ComplianceBadges'
}
</script>

<style scoped>
.compliance-badges {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
  animation: fadeInUp 0.8s ease-out 0.8s both;
}

.badge-compliance {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.badge-compliance:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.badge-compliance i {
  font-size: 1rem;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .compliance-badges {
    flex-direction: column;
    align-items: center;
  }

  .badge-compliance {
    width: auto;
    min-width: 200px;
    justify-content: center;
  }
}
</style>

